<tt-form-field-base
    #baseRef
    [ttFieldId]="id.input"
    [ttLabel]="ttLabel"
    [ttLabelView]="ttLabelView"
    [ttTranslateLabel]="ttTranslateLabel"
    [ttSublabel]="ttSublabel"
    [ttTranslateSublabel]="ttTranslateSublabel"
    [ttToggleTipText]="ttToggleTipText"
    [ttTranslateToggleTipText]="ttTranslateToggleTipText"
    [ttInvalid]="ttInvalid"
    [ttInvalidText]="ttInvalidText"
    [ttTranslateInvalidText]="ttTranslateInvalidText"
    [ttTextAlign]="ttTextAlign"
    [ttRequired]="ttRequired"
    [ttReadonly]="ttReadonly"
    [ttDisabled]="ttDisabled"
    [ttStyle]="ttStyle"
>
    <input
        class="tt-input__form-control"
        #inputRef
        [attr.id]="id.input"
        type="tel"
        [(ngModel)]="ttModel"
        (ngModelChange)="onModelChanged($event)"
        [ngStyle]="style['input']"
        (blur)="onBlur($event)"
        [readOnly]="ttReadonly"
        [disabled]="ttDisabled"
    />
    <ng-container buttons>
        <tt-form-field-button *ngIf="ttShowClearButton" ttId="$clear" ttIcon="fas fa-eraser" ttType="danger" (ttClick)="clearInput()"></tt-form-field-button>
        <tt-form-field-button *ngIf="ttShowPhoneButton" ttId="$phone" ttIcon="fas fa-mobile-alt" ttType="primary" (ttClick)="openPhone()"></tt-form-field-button>

        <tt-form-field-buttons *ngIf="ttButtons" [ttButtons]="ttButtons" [ttButtonParms]="ttButtonParms"></tt-form-field-buttons>
        <ng-content select="[buttons]"></ng-content>
    </ng-container>
</tt-form-field-base>
